import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "qr" }
const _hoisted_2 = {
  key: 0,
  class: "qr-steps"
}
const _hoisted_3 = { class: "qr-step-num" }
const _hoisted_4 = {
  key: 0,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3"
}
const _hoisted_5 = { class: "qr-step-name" }
const _hoisted_6 = {
  key: 1,
  class: "qr-progress"
}
const _hoisted_7 = { class: "qr-progress-text" }
const _hoisted_8 = { class: "qr-progress-bar" }
const _hoisted_9 = { class: "qr-cat-head" }
const _hoisted_10 = { class: "qr-cat-badge" }
const _hoisted_11 = { class: "qr-cat-title" }
const _hoisted_12 = { class: "qr-cat-name" }
const _hoisted_13 = { class: "qr-cat-meta" }
const _hoisted_14 = {
  key: 0,
  class: "qr-cat-state qr-cat-state--done"
}
const _hoisted_15 = {
  key: 1,
  class: "qr-cat-state"
}
const _hoisted_16 = {
  key: 0,
  class: "qr-cat-body"
}
const _hoisted_17 = { class: "qr-q-head" }
const _hoisted_18 = { class: "qr-q-num" }
const _hoisted_19 = { class: "qr-q-text" }
const _hoisted_20 = {
  class: "qr-options",
  role: "radiogroup"
}
const _hoisted_21 = ["name", "checked", "onChange"]
const _hoisted_22 = { class: "qr-letter" }
const _hoisted_23 = { class: "qr-opt-text" }
const _hoisted_24 = { class: "qr-footer" }
const _hoisted_25 = {
  key: 0,
  class: "qr-warn"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "qr-score" }
const _hoisted_28 = { class: "qr-score-info" }
const _hoisted_29 = { class: "qr-score-title" }
const _hoisted_30 = { class: "qr-score-sub" }
const _hoisted_31 = { class: "qr-score-meta" }
const _hoisted_32 = {
  key: 0,
  class: "qr-catscores"
}
const _hoisted_33 = { class: "qr-catscore-head" }
const _hoisted_34 = { class: "qr-catscore-name" }
const _hoisted_35 = { class: "qr-catscore-val" }
const _hoisted_36 = { class: "qr-catscore-bar" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "qr-cat-title" }
const _hoisted_39 = { class: "qr-cat-name" }
const _hoisted_40 = { class: "qr-cat-meta" }
const _hoisted_41 = {
  key: 0,
  class: "qr-cat-body"
}
const _hoisted_42 = { class: "qr-q-head" }
const _hoisted_43 = { class: "qr-q-num" }
const _hoisted_44 = { class: "qr-q-text" }
const _hoisted_45 = { class: "qr-options" }
const _hoisted_46 = { class: "qr-letter" }
const _hoisted_47 = { class: "qr-opt-text" }
const _hoisted_48 = {
  key: 0,
  class: "qr-opt-tag"
}
const _hoisted_49 = {
  key: 1,
  class: "qr-opt-tag"
}
const _hoisted_50 = {
  key: 0,
  class: "qr-blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.result)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.categories.length > 1)
            ? (_openBlock(), _createElementBlock("ol", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat, ci) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: cat.id,
                    class: _normalizeClass(["qr-step", { done: ci < _ctx.currentIndex, current: ci === _ctx.currentIndex }])
                  }, [
                    _createElementVNode("span", _hoisted_3, [
                      (ci < _ctx.currentIndex)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(ci + 1), 1)
                          ], 64))
                    ]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(cat.name), 1)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentCategory)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.categories.length > 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Categoria " + _toDisplayString(_ctx.currentIndex + 1) + " de " + _toDisplayString(_ctx.categories.length) + " · ", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.answeredCount), 1),
                  _createTextVNode(" de " + _toDisplayString(_ctx.currentCategory.questions.length) + " respondidas ", 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "qr-progress-fill",
                    style: _normalizeStyle({ width: _ctx.progressPct + '%' })
                  }, null, 4)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat, ci) => {
            return (_openBlock(), _createElementBlock("section", {
              key: cat.id,
              class: _normalizeClass(["qr-cat", { 'qr-cat--done': ci < _ctx.currentIndex, 'qr-cat--locked': ci > _ctx.currentIndex }])
            }, [
              _createElementVNode("header", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(ci + 1), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(cat.name), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(cat.questions.length) + " pergunta" + _toDisplayString(cat.questions.length === 1 ? '' : 's'), 1)
                ]),
                (ci < _ctx.currentIndex)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "3"
                      }, [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                      ], -1),
                      _createTextVNode(" Enviada ", -1)
                    ]))]))
                  : (ci > _ctx.currentIndex)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.2"
                        }, [
                          _createElementVNode("rect", {
                            x: "4",
                            y: "11",
                            width: "16",
                            height: "10",
                            rx: "2"
                          }),
                          _createElementVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" })
                        ], -1),
                        _createTextVNode(" Abre após a anterior ", -1)
                      ]))]))
                    : _createCommentVNode("", true)
              ]),
              (ci === _ctx.currentIndex)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.questions, (q, qi) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: q.id,
                        class: _normalizeClass(["qr-question", { 'qr-question--done': _ctx.answers[q.id] !== undefined }])
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(qi + 1), 1),
                          _createElementVNode("p", _hoisted_19, _toDisplayString(q.text), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.options, (opt, oi) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: oi,
                              class: _normalizeClass(["qr-option", { selected: _ctx.answers[q.id] === oi }])
                            }, [
                              _createElementVNode("input", {
                                class: "qr-radio",
                                type: "radio",
                                name: 'q-' + q.id,
                                checked: _ctx.answers[q.id] === oi,
                                onChange: ($event: any) => (_ctx.select(q.id, oi))
                              }, null, 40, _hoisted_21),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.letter(oi)), 1),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(opt), 1)
                            ], 2))
                          }), 128))
                        ])
                      ], 2))
                    }), 128)),
                    _createElementVNode("div", _hoisted_24, [
                      (_ctx.confirmUnanswered)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Você deixou " + _toDisplayString(cat.questions.length - _ctx.answeredCount) + " pergunta(s) sem resposta nesta categoria — elas contam como erradas. Clique novamente para confirmar. ", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "qr-submit",
                        type: "button",
                        disabled: _ctx.submitting,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                      }, _toDisplayString(_ctx.submitting ? 'Enviando...' : _ctx.isLast ? 'Enviar e finalizar' : 'Enviar e continuar'), 9, _hoisted_26)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", {
              class: _normalizeClass(["qr-score-ring", _ctx.tone(_ctx.result.scorePercent)]),
              style: _normalizeStyle({ '--pct': _ctx.result.scorePercent })
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.formatPct(_ctx.result.scorePercent)), 1)
            ], 6),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.scoreTitle), 1),
              _createElementVNode("p", _hoisted_30, [
                _cache[5] || (_cache[5] = _createTextVNode(" Você acertou ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.correctCount), 1),
                _cache[6] || (_cache[6] = _createTextVNode(" de ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.result.totalCount), 1),
                _cache[7] || (_cache[7] = _createTextVNode(" perguntas. ", -1))
              ]),
              _createElementVNode("p", _hoisted_31, [
                (_ctx.participantName)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.participantName) + " · ", 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode("Enviado em " + _toDisplayString(_ctx.formatDateTime(_ctx.result.submittedAt)), 1)
              ])
            ]),
            (_ctx.allowRetry)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "qr-retry",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('restart')))
                }, "Fazer novamente"))
              : _createCommentVNode("", true)
          ]),
          (_ctx.result.categoryScores && _ctx.result.categoryScores.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "qr-section-title" }, "Resultado por categoria", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.categoryScores, (cs) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: cs.categoryId,
                    class: "qr-catscore"
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(cs.name), 1),
                      _createElementVNode("span", _hoisted_35, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatPct(cs.scorePercent)), 1),
                        _createTextVNode(" · " + _toDisplayString(cs.correctCount) + "/" + _toDisplayString(cs.totalCount), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["qr-catscore-fill", _ctx.tone(cs.scorePercent)]),
                        style: _normalizeStyle({ width: cs.scorePercent + '%' })
                      }, null, 6)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultGroups, (group) => {
            return (_openBlock(), _createElementBlock("section", {
              key: group.key,
              class: "qr-cat qr-cat--result"
            }, [
              _createElementVNode("button", {
                class: "qr-cat-head qr-cat-head--toggle",
                type: "button",
                onClick: ($event: any) => (_ctx.toggleGroup(group.key))
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["qr-chevron", { open: _ctx.openGroups[group.key] }]),
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.6"
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                ]))], 2)),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(group.name || 'Respostas'), 1),
                  _createElementVNode("span", _hoisted_40, _toDisplayString(group.correct) + " certa" + _toDisplayString(group.correct === 1 ? '' : 's') + " · " + _toDisplayString(group.items.length - group.correct) + " errada" + _toDisplayString(group.items.length - group.correct === 1 ? '' : 's'), 1)
                ])
              ], 8, _hoisted_37),
              (_ctx.openGroups[group.key])
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (r, ri) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: r.questionId,
                        class: _normalizeClass(["qr-question qr-question--result", r.isCorrect ? 'is-correct' : 'is-wrong'])
                      }, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(ri + 1), 1),
                          _createElementVNode("p", _hoisted_44, _toDisplayString(r.text), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["qr-badge", r.isCorrect ? 'qr-badge--ok' : 'qr-badge--err'])
                          }, _toDisplayString(r.isCorrect ? 'Acertou' : 'Errou'), 3)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.options, (opt, oi) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: oi,
                              class: _normalizeClass(["qr-option qr-option--static", {
                  'mark-ok': r.selectedIndex === oi && r.isCorrect,
                  'mark-err': r.selectedIndex === oi && !r.isCorrect,
                  'mark-answer': r.correctIndex === oi && r.selectedIndex !== oi
                }])
                            }, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.letter(oi)), 1),
                              _createElementVNode("span", _hoisted_47, _toDisplayString(opt), 1),
                              (r.selectedIndex === oi)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Sua resposta"))
                                : (r.correctIndex === oi)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Resposta correta"))
                                  : _createCommentVNode("", true)
                            ], 2))
                          }), 128)),
                          (r.selectedIndex === null)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_50, "Sem resposta"))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 64))
  ]))
}